export const BVT_USER = "bvt@bvarta.com";
export const INTERNAL_TESTER_USER = "automation@bvarta.com";

export const EXCLUDED_EMAILS_FROM_TRACKING: ReadonlySet<string> = new Set([
  BVT_USER,
  INTERNAL_TESTER_USER
]);
